"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "../internal/cx.js";
import { IconInbox } from "../internal/icons.js";
import { Button } from "./Button.js";
import { InfoTip } from "./InfoTip.js";
/** Nothing to show: an icon, one line, at most one action; the explanation behind «?». */
export function EmptyState({ icon, children, action, hint, compact, className }) {
    const isAction = (value) => !!value && typeof value === "object" && "onClick" in value && "label" in value;
    return _jsxs("div", { className: cx("jui-empty", compact && "jui-empty--compact", className), role: "status", children: [_jsx("span", { className: "jui-empty-icon", children: icon ?? _jsx(IconInbox, {}) }), _jsxs("span", { className: "jui-empty-text", children: [children, hint && _jsx(InfoTip, { children: hint })] }), isAction(action) ? _jsx(Button, { size: "sm", variant: "secondary", icon: action.icon, onClick: action.onClick, children: action.label }) : action] });
}
